import React, { useEffect, useState, useRef } from 'react'
import ImageNotAvailable from '../../../assets/image-not-available.png'
import PlayIcon from '../../../assets/Content-Icons/Svgs/play-circle.svg'
import SelectedTagIcon from '../../../assets/Content-Icons/Svgs/selected-tag-icon.svg'
import CustomImage from 'src/components/customImage/customImage'
import InformationTagIcon from '../../../assets/Content-Icons/Svgs/information-tag-icon.svg'

const CustomListCard = ({
  cardStyle = {},
  onSelect = null,
  cardImage = '',
  fileName = '',
  releasedDate = '',
  duration = '',
  contentType = '',
  // category = '',
  categories = [],
  isSelectable = false,
  isMutipleSelectable = false,
  isCategory = true,
  isSelected = false,
  actionButton = '',
  actionButtonAction = {},
  actionButtonDisable = false,
  fileNameWidth = '20%',
  durationWidth = '10%',
  releasedDateWidth = '10%',
  contentTypeWidth = '10%',
  categoryWidth = '20%',
  categoryMarginRight = '-2%',
}) => {
  const categoryStyles = {
    background: '#d6d2d2',
    padding: '.25ch 1ch',
    borderRadius: '10px',
    marginRight: '.5vw',
    display: 'inline-block',
  }

  const elementRef = useRef([])
  const containerElementRef = useRef(null)
  const [contentCategories, setContentCategories] = useState(categories)

  const [extraCategories, setExtraCategories] = useState([])
  const [visibleCategories, setVisibleCategories] = useState([])

  useEffect(() => {
    let tempExtraCategory = []
    let tempExtraCategoryTexts = []
    let categoriesContainerWidth = containerElementRef.current.clientWidth // categories container width
    let categoriesWidths = elementRef.current.map((item) => item.clientWidth) // categories Width(s) array
    let categoriesTexts = elementRef.current.map((item) => item.innerHTML) // categories Text(s) array
    let getSumOfCategoriesWidth = () => categoriesWidths.reduce((a, b) => a + b, 0) // getter for sum of categories width(s)

    while (getSumOfCategoriesWidth() > categoriesContainerWidth) {
      tempExtraCategory.push(categoriesWidths.pop())
      tempExtraCategoryTexts.push(categoriesTexts.pop())
    }
    setVisibleCategories(categoriesTexts)
    setExtraCategories(tempExtraCategory)
  }, [])

  useEffect(() => {
    setContentCategories(visibleCategories)
  }, [visibleCategories])

  return (
    <div
      style={{
        width: '100%',
        aspectRatio: '1181/78',
        boxShadow: ' 3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        display: 'flex',
        justifyContent: 'center',
        background: '#ececec',
        gap: '0 2.2%',
        padding: '.4vw 0',
        ...cardStyle,
      }}
      className={`${isSelectable ? 'on-card-hover' : ''} on-card-selected rounded-1`}
      tabIndex={0}
      onClick={isSelectable ? onSelect : null}
    >
      <div className="relative" style={{ height: '100%', width: '9%' }}>
        <CustomImage
          className="card-img-top"
          imageUrl={cardImage}
          loaderStyle={{ height: '100%' }}
          errorPlaceholder={ImageNotAvailable}
          alt={'Asset'}
          imgStyle={{
            opacity: isSelectable ? '1' : '.36',
            pointerEvents: isSelectable ? 'all' : 'none',
            height: '100%',
            width: '100%',
            objectFit: 'cover',
          }}
        />
        {isSelectable && (
          <img
            src={SelectedTagIcon}
            alt=""
            className={`selected-tag ${isSelected ? 'selected-content' : ''}`}
          />
        )}
        {!isSelectable && (
          <div className={`information-tag`}>
            <img src={InformationTagIcon} alt="" />
          </div>
        )}
        {/* {playIconForVideo && (
          <div className="play-icon">
            <img src={PlayIcon} alt="" />
          </div>
        )} */}
      </div>
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          background: 'none',
          width: '85%',
          opacity: isSelectable ? '1' : '.36',
          pointerEvents: isSelectable ? 'all' : 'none',
        }}
      >
        <div
          style={{ fontSize: '12px' }}
          className="d-flex justify-content-between align-items-center w-100"
        >
          <p
            style={{
              marginBlockEnd: '0',
              fontWeight: '600',
              fontSize: '14px',
              width: fileNameWidth,
              background: 'none',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {fileName}
          </p>
          <p style={{ marginBlockEnd: '0', width: durationWidth, background: 'none' }}>
            {duration.includes(':') ? duration.replace(':', ' ') : duration}
          </p>
          <p style={{ marginBlockEnd: '0', width: releasedDateWidth, background: 'none' }}>
            {releasedDate}
          </p>
          <p style={{ marginBlockEnd: '0', width: contentTypeWidth, background: 'none' }}>
            {contentType}
          </p>
          <p
            style={{
              marginBlockEnd: '0',
              width: categoryWidth,
              background: 'none',
              marginRight: categoryMarginRight,
              whiteSpace: 'nowrap',
              flexShrink: '0',
            }}
            ref={containerElementRef}
          >
            {contentCategories.map((category, idx) => (
              <span
                style={isCategory ? categoryStyles : { marginLeft: idx ? '2vw' : '' }}
                ref={(el) => (elementRef.current[idx] = el)}
                key={idx}
              >
                {category}
              </span>
            ))}
            {extraCategories.length > 0 && <span>+{extraCategories.length}</span>}
          </p>

          {!actionButtonDisable && (
            <div
              style={{
                width: '2%',
                fontSize: '20px',
                fontWeight: '700',
                cursor: 'pointer',
              }}
              className="d-flex justify-content-center align-items-center position-relative preview-menu-dots"
            >
              <button style={{ border: 'none', outline: 'none', background: 'none' }}>⋮</button>
              <div
                className="position-absolute preview-menu-button"
                style={{ left: '-400%' }}
                onClick={() => {
                  actionButtonAction()
                  // onSelect()
                }}
                tabIndex={0}
              >
                {actionButton}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default CustomListCard

/*
.on-card-hover - Applies the hover effect to the card
.on-card-selected - Applies the selected effect to the card
.play-icon - Applies the play icon effect to the card which is of type "video", it is absolute on the thumbnail (search for the class for more)

displayAsListItem - display the card as a list item(if true) or a grid item(if false)

publish_time - start
live_exp_tiem - end time

/////// for live
*/
